/* eslint-disable camelcase */

export default {
	new_authorization_letter: 'New authorization letter',
	authorization_letter: 'Authorization letter',
	are_you_sure__to_void_letter_of_authorization: 'Are you sure you want to void the letter of authorization'
};
